
import React, { Component } from "react";
import {InputGroup, InputLeftAddon, InputRightAddon, Input} from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";


export default class TextInput extends Component 
{
    constructor(props)
    {
        super(props);

        this.incrementValue = this.incrementValue.bind(this);
        this.decrementValue = this.decrementValue.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    onChange(e)
    {
      this.props.onValueChange(e.target.value, this.props.card.id);
    }


    incrementValue() 
    {
        var newVal = (this.props.cardValue) ? parseInt(this.props.cardValue) + 1 : 1;
        this.props.onValueChange(newVal);
      }
    
      decrementValue() 
      {
        if ((!this.props.cardValue) || (this.props.cardValue === 0)) return;
        var newVal = parseInt(this.props.cardValue) -1;
        this.props.onValueChange(newVal);
      }

    render() 
    {
        return (
              <InputGroup>
                <InputLeftAddon
                  children={<FontAwesomeIcon icon={faMinus} />}
                  onClick={() => this.decrementValue()}
                />
                <Input
                  autoFocus
                  textAlign={"center"}
                  type='number'
                  placeholder={this.props.valueBag[this.props.card.id] ? this.props.valueBag[this.props.card.id] : '0'}
                  value={this.props.cardValue}
                  bg='white'
                  onChange={(e) => this.onChange(e)}
                />
                <InputRightAddon
                  children={<FontAwesomeIcon icon={faPlus}
                    onClick={() => this.incrementValue()}
                  />} />
              </InputGroup>
          );
    }
}







